export const environment = {
  production: false,
  appVersion: 'v8.2.4',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'https://api.tkc-hr.dev.riseplus.tech/api',
  apiUrl_image: 'https://api.tkc-hr.dev.riseplus.tech',
  appPreviewChangelogUrl:
    'https://preview.keenthemes.com/metronic8/angular/docs/changelog',
};
